module.exports = __webpack_public_path__ + "media/images/builder_hero_new-73aa85d9.png";